import {
  ONE_TRUST_ACTIVE_GROUPS_NAMESPACE,
  NECESSARY_COOKIES_ID,
  SITE_ANALYTICS_COOKIES_ID,
  CUSTOMER_PREFERENCES_COOKIES_ID,
  TARGETING_AND_ADVERTISING_COOKIES_ID,
  SOCIAL_MEDIA_COOKIES_ID
} from "../constants.js";

/**
 * Get the current consent from the OneTrust window namespace.
 *
 * If the window namespace does not exist, then `null` is returned.
 *
 * @returns {object|null}
 */
export const getConsentFromWindow = () => {
  const consentString = window[ONE_TRUST_ACTIVE_GROUPS_NAMESPACE];

  if (!consentString) {
    return null;
  }

  return {
    [NECESSARY_COOKIES_ID]: true,
    [SITE_ANALYTICS_COOKIES_ID]: consentString.includes(
      SITE_ANALYTICS_COOKIES_ID
    ),
    [CUSTOMER_PREFERENCES_COOKIES_ID]: consentString.includes(
      CUSTOMER_PREFERENCES_COOKIES_ID
    ),
    [TARGETING_AND_ADVERTISING_COOKIES_ID]: consentString.includes(
      TARGETING_AND_ADVERTISING_COOKIES_ID
    ),
    [SOCIAL_MEDIA_COOKIES_ID]: consentString.includes(SOCIAL_MEDIA_COOKIES_ID)
  };
};
